/**
 * event types for events emitted by toolbar
 */
export enum WlProfilesToolbarEventTypeEnum {
  search,
  searching,
  clearKeyword,
  newProfile,
  requestKeyword,
  requestKeywordAnswer,
}
